import VueRouter from 'vue-router';
import { mapMutations } from 'vuex'
import store from './store'


import Register from './views/auth/Register';
import Start from './views/auth/Start';
import Login from './views/auth/Login';
import Join from './views/auth/Join';

import Error404 from './views/errors/Error404';

import Org from './views/Org';
import UserOrgs from './views/UserOrgs';
import OrgHome from './views/Org/OrgHome';
import OrgTeam from './views/Org/OrgTeam';
import OrgSettings from './views/Org/OrgSettings';
import OrgBilling from './views/Org/OrgBilling';

import Template from './views/Template';
import TemplateHome from './views/Template/TemplateHome';
import TemplateConfigs from './views/Template/TemplateConfigs';
import TemplateEdit from './views/Template/TemplateEdit';


import Configs from './views/Configs';
import Config from './views/Config';

import NewTemplate from './views/NewTemplate';
import UserHome from './views/UserHome';
import UserSettings from './views/UserSettings';

let routes = [

	// -----------------------------------
	// Auth


	{
		path: '/start',
		component: Start,
		meta : {
			title : 'Get started',
			is_public : true,
		},
	},

	{
		path: '/register',
		component: Register,
		name: 'auth.register',
		meta : {
			title : 'Register',
			is_public : true,
		},
	},

	{
		path: '/login',
		component: Login,
		name: 'auth.login',
		meta : {
			title : 'Login',
			is_public : true,
		},
	},

	{
		path: '/join/:invite_id',
		component: Join,
		name: 'auth.join',
		meta : {
			title : 'Join team',
			is_public : true,
		},
	},

	{
		path: '/logout',
		meta : {
			title : 'Logging out...',
		},
	},

	// -----------------------------------
	// Main options

	{
		path: '/',
		component: UserHome,
		name : 'templates',
		meta : {
			title : 'Your templates',
		},
	},

	{
		path: '/templates/new',
		name: 'template.new',
		component: NewTemplate,
		meta : {
			title : 'New Template',
		},
	},

	{
		path: '/templates/:template_id(\\d+)',
		component: Template,
		meta : {
			title : 'Template',
		},

		children: [

			// DEFAULT
			{
				path: '',
				component: TemplateHome,
				name: 'template',
				meta : {
					title : 'Template Overview',
				},
			},

			// Edit
			{
				path: 'edit',
				component: TemplateEdit,
				name: 'template.edit',
				meta : {
					title : 'Edit template',
				},
			},

			// Edit
			{
				path: 'configs',
				component: TemplateConfigs,
				name: 'template.configs',
				meta : {
					title : 'Generated Configs',
				},
			},


		],

	},

	

	{
		path: '/configs',
		component: Configs,
		name : 'configs',
		meta : {
			title : 'Saved configs',
		},
	},
	{
		path: '/configs/:config_id(\\d+)',
		component: Config,
		name : 'config',
		meta : {
			title : 'Config',
		},
	},

	{
		path: '/settings',
		name:'settings',
		meta : {
			title : 'Manage your profile',
		},
		component: UserSettings,
	},

	{
		path: '/orgs',
		name: 'orgs',
		meta : {
			title : 'Organisations you are part of',
		},
		component: UserOrgs,
	},


	// ---------------------
	// Org

	{
		path: '/orgs/:org_id(\\d+)',
		component: Org,
		meta : {
			title : '',
			requires_org : true,
		},

		children: [

			// DEFAULT
			{
				path: '',
				name: 'org',
				component: OrgHome,
				meta : {
					title : 'Org Home',
				},
			},

			{
				path: 'team',
				name: 'org.team',
				component: OrgTeam,
				meta : {
					title : 'Org Team',
				},
			},

			{
				path: 'settings',
				name: 'org.settings',
				component: OrgSettings,
				meta : {
					title : 'Org Settings',
				},
			},

			{
				path: 'billing',
				name: 'org.billing',
				component: OrgBilling,
				meta : {
					title : 'Org Billing',
				},
			},

		],
	},


	// ---------------------
	// Catch all

	{
		path: '*',
		component: Error404,
		meta : {
			title : 'Page not found',
			is_public : true,
		},
	},

]; // END ROUTES


const router = new VueRouter({
	mode: 'history',
	scrollBehavior() {
	  return { x: 0, y: 0 };
	},
	routes
});


router.beforeEach((to, from, next) => {
	
	Event.$emit('page-loading', {} );

	return store.dispatch('auth/check')
		.then(function(logged_in){
			return logged_in;
		})
		.catch(function(){
			return false;
		})
		.then(function(logged_in){
			// 1) If logout, logout and direct to login
			if( to.fullPath == '/logout' ){
				return store.dispatch('auth/logout').then(function(){
					return next({
						path: '/login',
					});
				})
				
				// 2) If not a public page, direct to login
			} else if( to.matched.some(record => !record.meta.is_public) && !logged_in){
				
				Event.$emit('info','You need to log in to view that page.');

				return next({
					path: '/login',
					query: { redirect: to.fullPath }
				});
				
				// Otherwise continue
			} else {
				return next();
			}
		});

})


router.afterEach((to, from) => {
	Event.$emit('page-loaded', {} );

	setTimeout(function(){
		if(!to.meta.title) alert('No page title set')
		document.title = (to.meta.title || 'NO TITLE') + TITLE_END;
	},10); // Needs delay to attach the title to the correct history item

})

export default router;